/* Base translations · Engagements, executive view, reports and documents — moved unchanged out of lib/i18n.js (STEP 6 · split 6f).
   Top-level keys owned by this file (no other base file and not i18n.js define them): engagements, executive, eng, report, completion, w17_e3, review, forms, docs, ailog. */
export const I18N_BASE_ENGAGEMENTS = {
  en: {
    w17_e3: {
      repDateAfterReport: "Representation date is after the report date.",
      refusalPathTitle: "Management refusal — record the response",
      refusal_discussPh: "Discussion with management / those charged with governance",
      refusal_reevaluatePh: "Re-evaluation of management integrity",
      refusal_effectPh: "Effect on the conclusion",
    },
    forms: {
      // N1 · G7 — audit-only-form labels shown in the forms library on
      // Review engagements. Every id in AUDIT_ONLY_FORMS gets a label
      // (never auto-humanised — R5).
      team_discussion: "Engagement-team discussion (ISA 315 / ISA 240)",
      overall_audit_strategy: "Overall audit strategy",
      detailed_audit_plan: "Detailed audit plan",
      risk_report_risk_addressed: "Risk-response matrix",
      control_design_fsa_worksheet: "Controls design worksheet",
      external_confirmations_control: "Confirmations control worksheet",
      opening_balances: "Opening balances (A9003)",
      audit_completion_checklist: "Audit completion checklist",
      reporting_checklist: "Auditor's-report reporting checklist",
      report_approval_and_transmittal: "Auditor's-report approval",
      group_audit_scoping: "Group-audit scoping",
      reliance_internal_audit: "Reliance on internal audit",
      auditors_expert: "Auditor's expert",
    },
    review: {
      notUsed: "Not used in a review",
      notUsedAr: "غير مستخدم في ارتباط الفحص",
      enableTitle: "Enable for this engagement",
      enableHint: "Any engagement-team auditor may enable this for a documented review matter (additional or alternative procedure). The change is logged.",
      enableReasonPh: "Reason (required)",
      enableBtn: "Enable for this engagement",
      pageEnableReasonRequired: "A reason is required.",
      pageEnabledOk: "Enabled for this engagement.",
      pageDisabledOk: "Disabled for this engagement.",
      enabledBadge: "Enabled \u2713",
    },
    // Batch C · Round C1 — Initial vs Continuing engagement field
    eng: {
      status: {
        label: "Initial / continuing engagement",
        initial: "Initial engagement",
        continuing: "Continuing engagement",
        notSet: "Not set — choose Initial or Continuing",
        hint: "Choose 'Initial engagement' for a first-time audit (drives ISA 510 procedures + 213(a)); choose 'Continuing' for a repeat audit (roll-forward only).",
      },
    },
    report: {
      titleAudit: "Auditor's Report", titleReview: "Review Report", loadFailed: "Could not load the report", generated: "Report version created",
      signatoryTitle: "Signature block", signatoryName: "Signing partner (name)", signatoryLicence: "Licence number",
      signatoryHint: "Optional. Printed under the firm's signature block only when filled — on screen, in Word and in the Final PDF. Regenerate the report after a change.",
      signatorySaved: "Signatory saved", signatorySaveFailed: "Could not save the signatory",
      generateFailed: "Generate failed", editFailed: "Edit failed", generate: "Generate", regenerate: "Regenerate (new version)", word: "Word (.docx)",
      partnerSignoff: "Partner sign-off", makeFinal: "Make Final", finalDone: "Report is Final", finalBlocked: "Final gate not met",
      signoffWarningsTitle: "Sign-off warnings (they do not block the report)",
      partnerUnsigned: "The Partner has not signed this report version",
      finalPartnerOnly: "Only the engagement partner can make the report Final",
      whyTitle: "Why this report", overridden: "Partner override", compareWith: "Compare with…", differences: "differences",
      mergeTitle: "Manual edits from the previous version — keep mine or take new", keepMine: "Keep mine", takeNewHint: "(new text already shown below)",
      reasonRequired: "Reason for changing required wording (required)", requiredWording: "Required wording (ISA / ISRE)", aiDraft: "AI draft",
      requiredChanged: "Required wording changed", empty: "No report version yet — click Generate.",
      aiEstimate: "Draft with AI: estimated {units} units for {n} paragraph(s). Continue?", aiDrafted: "{n} paragraph(s) drafted — review and accept", aiFailed: "AI draft failed",
      draftAll: "Draft all with AI", draftWithAi: "Draft with AI", accept: "Accept", reject: "Reject", sources: "Sources", downloadFailed: "Download failed",
      pdfFinal: "PDF (Final)", uploadFinal: "Upload signed final report (PDF)", finalFile: "Signed final report", uploadStored: "Signed final report stored with the engagement and locked",
      w12Link: "Changes only through W12 post-assembly amendment →", finalNote: "This report is Final. Any change goes through the W12 post-assembly amendment (reason + reviewer).",
      regenNeeded: "Regenerate needed — framework changed ({from} → {to}, by {by} on {at}). Existing versions are kept read-only.",
      fwMismatch: "This version was built on a different framework than the FS / Disclosure Checklist. Regenerate before Final.",
      eomOmTitle: "Emphasis of Matter / Other Matter entries", eom: "Emphasis of Matter", om: "Other Matter", topic: "Topic", noteRef: "Note ref", note: "Note", addEntry: "Add entry", eomText: "Text (AI-draftable on the report)",
    },
    engagements: {
      title: "Engagements",
      // Batch 10 · Stage A — Copy engagement
      rfAction: "Roll forward to next year",
      rfTitle: "Roll forward to next year",
      rfDesc: "A new engagement for the next financial year: same client, team and settings, status Planning. This year's GL and TB become its prior year.",
      rfName: "Name of the new engagement",
      rfYear: "Financial year {fy} · period {from} to {to}",
      rfDatesAsk: "This engagement has no period dates. Enter the period of the new engagement (financial year {fy}).",
      rfStartLabel: "Period start",
      rfEndLabel: "Period end",
      rfCarried: "Carried and marked 'Carried forward — update for current year' (not complete until saved again): forms, risk register and responses, disclosure-checklist answers, the related-party list. The FS mapping is carried; the prior year's estimates and materiality are shown read-only.",
      rfNotCarried: "Not carried: materiality, worksheets, samples, vouching, misstatements, sign-offs, review points, reports, the audit trail, and documents that are not ticked 'Permanent file'. The prior-year figures of the new year are the AUDITED closing figures: the client books plus this year's posted adjusting entries (kept on the new year as read-only prior-year audit adjustments).",
      rfDocs: "Permanent-file documents to carry",
      rfDocsNone: "No document is ticked 'Permanent file'. Tick them on the Documents page first.",
      rfSuggested: "Not ticked, but these look like permanent-file documents (tick them on the Documents page to carry them):",
      rfAlready: "This engagement was already rolled forward to FY{fy}.",
      rfStart: "Roll forward",
      rfRunning: "Rolling forward…",
      rfQueued: "Queued",
      rfDone: "Ready: {name}",
      rfFailed: "The roll forward failed",
      rfOpen: "Open the new engagement",
      copyAction: "Copy engagement",
      copyTitle: "Copy engagement",
      copyDesc: "Makes a new, open engagement of the same client and financial year with this engagement's work. The source is not changed.",
      copyName: "Engagement name of the copy",
      copyNameHint: "Shown in the selector, lists and Dashboard. The client's legal name ({client}) is copied unchanged — it prints in the auditor's report and the FS.",   // Batch 14 · M13
      copyRef: "Firm engagement reference of the copy",
      copySameFy: "Financial year {fy} (same as the source)",
      copyTickGl: "GL and TB imports (main and head-wise)",
      copyTickDocs: "Documents (each file is copied; nothing is shared)",
      copyTickSamples: "Samples and vouching sheets",
      copyTickMisst: "Misstatements",
      copyNever: "A copy is new work. Never copied: sign-offs of any kind (item Preparer / Reviewer 1 / EQ reviewer / Partner, form workflow marks, W9 / W10 / EQ / report sign-offs — they record who reviewed the ORIGINAL file), the EQ review (appointment and matters — redone on the copy), the auditor's report versions, lock and file assembly, audit-trail history, review points and notifications. Copied: the W12 report date (file content). The copy opens unlocked.",
      copyStart: "Copy",
      copyRunning: "Copying…",
      copyQueued: "Queued",
      copyDone: "Copy ready: {name}",
      copyFailed: "The copy could not be made — try again",
      copyOpen: "Open the copy",
      subtitle: "Client audit engagements",
      newEng: "New engagement",
      client: "Client",
      fy: "Financial Year",
      currency: "Currency",
      materiality: "Materiality",
      overallMateriality: "Overall Materiality",
      performanceMateriality: "Performance Materiality",
      clearlyTrivial: "Clearly trivial (optional)",   // Batch 27 · D (M37)
      clearlyTrivialHint: "Leave empty to set it later in 105(a). No default is assumed.",
      firmRef: "Firm Engagement Ref",
      engName: "Engagement name", rename: "Rename the engagement", renamePrompt: "Engagement name (shown in the selector, lists and Dashboard; the client's legal name in the report is not changed):", renamed: "Engagement renamed",   // Batch 14 · M13
      lockedLabel: "Locked", reportFinalLabel: "Report Final",   // Batch 14 · M14
      firmRefHint: "Your firm's own internal engagement / job number",
      periodEnd: "Period End",
      periodStart: "Period start",
      periodStartHint: "Leave blank for 12 months before the period end.",
      addEng: "New engagement",
      addTitle: "Create new engagement",
      contractedFee: "Total Contracted Revenue / Fee",
      contractedFeeHint: "Partner-editable only. Used by Billing / Over Run tab.",
      budgetedHours: "Total Budgeted Hours",
      budgetedHoursHint: "Actual hours may exceed this — engagement will be flagged as Over Run.",
      seedNote: "Initial seed values only. After the engagement is created, all changes to Materiality / Performance Materiality must go through {matPath}; every other screen (Sampling, etc.) pulls from there automatically.",
      seedNotePath: "Risk Assessment → Materiality",
      pfLabel: "Presentation Framework",
      pfErrorSelect: "Select a presentation framework (IAS 1 or IFRS 18) before creating the engagement.",
      pfNote: "Governs Profit & Loss rendering (IFRS 18 category subtotals vs. IAS 1 traditional). Changeable later by the Partner in Engagement Settings; after the first FS generation a change keeps existing versions read-only and marks the FS \"Regenerate needed\".",
      pfPlaceholder: "e.g. ENG-2024-017",
      requiresEqcLabel: "Requires EQ review",
      isaCitationEqc: "(ISQM 1 — engagement quality reviews; ISA 220 (Revised)) — listed entities & higher-risk engagements",
      supportDocsLabel: "Supporting documents for this engagement",
      glSamplesCol: "GL / Samples",
      findingsCol: "Findings",
      signedOff: "Signed Off",
      manageTeam: "Manage engagement team",
      deleteEngUnlockFirst: "Unlock the engagement before deleting",
      deleteEngTooltip: "Delete engagement",
      deleteEngTitle: "Delete engagement?",
      deleteEngDesc: "This moves {client} (FY {fy}) and everything in it to the Recycle Bin. It disappears from the engagement list and can be restored from the Recycle Bin; nothing is hard-deleted.",
      noClientName: "(no client name)",
      clientNameRequired: "Enter the client name before creating the engagement.",
      deleteEngYes: "Yes, delete",
      created: "Engagement created",
      deleted: "Engagement deleted",
      deleteFailed: "Delete failed",
      failedCreate: "Failed",
      pfSetTooltip: "Set presentation framework",
      pfWithLabel: "Framework: {pf}",
    },
    executive: {
      title: "Executive Dashboard",
      // Batch 24 — engagements in the Recycle Bin: not counted in the KPIs, listed in a collapsed card
      deletedTitle: "Deleted engagements ({n})", deletedHint: "In the Recycle Bin — not counted in the figures above. Restore one from the Recycle Bin.",
      dName: "Engagement", dDeletedAt: "Deleted on", dDeletedBy: "Deleted by", deletedShow: "Show", deletedHide: "Hide",
      subtitle: "Portfolio-wide progress, risk and materiality across every engagement",
      failedLoad: "Failed to load",
      kpiEngagements: "Engagements",
      kpiSamples: "Samples tested",
      kpiDocs: "Documents",
      kpiHigh: "High findings",
      kpiGl: "GL entries",
      kpiBurn: "Firm-wide burn",
      kpiInProgress: "{n} in progress",
      state: { completed: "Completed", signed_off: "Signed off", in_progress: "In progress", planning: "Planning" },
      kpiCoverage: "{n}% coverage",
      kpiPending: "{n} pending items",
      kpiFindingsBreak: "+{m} med · {l} low",
      kpiFirmwide: "firm-wide",
      kpiIdentified: "{n} identified",
      portfolio: "Engagement portfolio",
      cClient: "Client",
      cFirmRef: "Firm Ref",
      cFy: "FY",
      cStatus: "Status",
      cProgress: "Progress",
      cBurn: "Materiality burn-down",
      cHigh: "High",
      cMed: "Med",
      cLow: "Low",
      cPending: "Pending",
      noEng: "No engagements yet.",
      signedOffBy: "Signed off by {name}",
      vouchingTested: "{done} / {total} tested",
      heatMap: "Risk heat map (ISA 315)",
      heatMapEmpty: "No FS-area risk items entered yet. Add risks on the Risk Assessment page (ISA 315 tab) for each engagement.",
      findingsByType: "Findings by type",
      noFindings: "No findings yet.",
      burnTitle: "Materiality burn-down (ISA 450)",
      burnDesc: "Aggregate identified misstatements per engagement vs its performance materiality. Green < 50% · Amber 50% to < 100% · Red \u2265 100% (at or over PM).",
      burnLabel: "Burn",
      burnLegend: "Burn %",
    },
    docs: {
      title: "Document Review",
      subtitle: "Upload supporting documents and review AI-extracted fields",
      type: "Document type",
      types: {
        auto: "Auto-detect (recommended)",
        sales_invoice: "Sales invoice",
        auto: "Detected automatically", other_information: "Other information", grn: "Goods received note", bank_statement: "Bank statement",
        purchase_invoice: "Purchase invoice", po: "Purchase order", contract: "Contract", boq: "Bill of quantities", delivery_note: "Delivery note",
        unclassified: "Unclassified", org_logo: "Firm logo", financial_statements: "Financial statements", methodology: "Methodology",
        purchase_invoice: "Purchase invoice",
        po: "Purchase order",
        contract: "Contract / Agreement",
        boq: "Bill of Quantities",
        grn: "Goods Receiving Note",
        delivery_note: "Delivery note",
        bank_statement: "Bank statement",
        confirmation: "Balance confirmation",
        subcontractor_certificate: "Subcontractor certificate",
        progress_certificate: "Progress certificate",
        memo: "Memo / internal document",   // Batch 29 · item 8
        unclassified: "Unclassified — review",
      },
      linkTo: "Link to vouching items",
      linkMulti: "One document can be linked to multiple sample lines.",
      manageLinks: "Manage links",
      linkedTo: "Linked to",
      unlink: "Unlink",
      delete: "Delete document",
      deleteConfirm: "Delete this document? This cannot be undone.",
      extracted: "Extracted fields",
      preview: "Document preview",
      upload: "Upload document",
      pending: "Reading the document…",
      retry: "Retry", retryQueued: "Reading queued — the state updates when it finishes.",
      done: "Extracted",
      failed: "Extraction failed",
      dropzone: "Drop file here or click to browse",
    },
    completion: {
      a4: {
        seeAlso: "See also:",
        finalEval: "Going Concern — Final evaluation and conclusion",
      },
    },
    ailog: {
      tab: "AI log", thisEng: "This engagement", allEng: "All engagements", allFeatures: "All features", allUsers: "All users", export: "Export XLSX",
      empty: "No AI runs recorded yet", calls: "call(s)",
      col: { when: "When", user: "User", feature: "Feature", engagement: "Engagement", asked: "What was asked", returned: "What the AI returned", sources: "Sources", units: "Units", decision: "Decision" },
      dec: { accept: "Accepted", edit: "Edited & accepted", reject: "Rejected", mixed: "Partly accepted", pending: "No decision yet" },
      feature: { risk_ai_suggest: "AI suggest risks", dc_ai_premark: "Disclosure checklist AI pre-mark", bulk_ai_suggest: "Forms AI suggest (all forms)", ai_readout: "AI Readout", analytics_observations: "Analytics AI observations", unit_test: "Test", methodology_extract: "Methodology extraction", report_narrative_draft: "Auditor's report narrative drafting", report_firm_adaptation: "Firm-style report wording", discrepancy_explain: "Discrepancy explainer", note_mapping_suggest: "AI suggest note mapping", unknown: "Uncategorised", assistant_chat: "AI assistant", form_ai_suggest: "Form AI suggest", fs_mapping_suggest: "FS mapping suggest", note_editorial_draft: "Note editorial draft", doc_extraction: "Document extraction", doc_summary: "Document summaries" },
    },
  },
  ar: {

    w17_e3: {
      repDateAfterReport: "تاريخ الإفادة بعد تاريخ التقرير.",
      refusalPathTitle: "امتناع الإدارة — سجِّل الرد",
      refusal_discussPh: "المناقشة مع الإدارة / المكلفين بالحوكمة",
      refusal_reevaluatePh: "إعادة تقييم نزاهة الإدارة",
      refusal_effectPh: "الأثر على الاستنتاج",
    },
    forms: {
      team_discussion: "مناقشة فريق الارتباط (\u2066ISA 315\u2069 / \u2066ISA 240\u2069)",
      overall_audit_strategy: "الاستراتيجية العامة للمراجعة",
      detailed_audit_plan: "خطة المراجعة التفصيلية",
      risk_report_risk_addressed: "مصفوفة الاستجابة للمخاطر",
      control_design_fsa_worksheet: "ورقة تصميم الضوابط",
      external_confirmations_control: "ورقة ضبط المصادقات",
      opening_balances: "الأرصدة الافتتاحية (\u2066A9003\u2069)",
      audit_completion_checklist: "قائمة إتمام المراجعة",
      reporting_checklist: "قائمة تقرير المراجع",
      report_approval_and_transmittal: "اعتماد وإرسال تقرير المراجع",
      group_audit_scoping: "تحديد نطاق مراجعة المجموعة",
      reliance_internal_audit: "الاعتماد على المراجعة الداخلية",
      auditors_expert: "خبير المراجع",
    },
    review: {
      notUsed: "غير مستخدم في ارتباط الفحص",
      notUsedAr: "Not used in a review",
      enableTitle: "تفعيل هذه الصفحة لهذه المهمة",
      enableHint: "يجوز لأي عضو من فريق المهمة تفعيل هذا لموضوع فحص موثَّق (إجراء إضافي أو بديل). يُسجَّل التغيير.",
      enableReasonPh: "السبب (مطلوب)",
      enableBtn: "تفعيل لهذه المهمة",
      pageEnableReasonRequired: "السبب مطلوب.",
      pageEnabledOk: "تم تفعيل الصفحة لهذه المهمة.",
      pageDisabledOk: "تم إيقاف الصفحة لهذه المهمة.",
      enabledBadge: "مُفعَّل \u2713",
    },
    // Batch C · Round C1 — Initial / Continuing engagement (AR)
    eng: {
      status: {
        label: "ارتباط أولي / مستمر",
        initial: "ارتباط أولي",
        continuing: "ارتباط مستمر",
        notSet: "غير محدد — اختر أولي أو مستمر",
        hint: "اختر «ارتباط أولي» للمراجعة لأول مرة (يُفعّل إجراءات ISA 510 و213(a))، واختر «مستمر» للمراجعة المتكررة (المطابقة فقط).",
      },
    },

    report: {
      signatoryTitle: "كتلة التوقيع", signatoryName: "الشريك الموقِّع (الاسم)", signatoryLicence: "رقم الترخيص",
      signatoryHint: "اختياري. يُطبع أسفل كتلة توقيع الشركة فقط عند تعبئته — على الشاشة وفي Word وفي ملف PDF النهائي. أعد توليد التقرير بعد أي تغيير.",
      signatorySaved: "تم حفظ الموقِّع", signatorySaveFailed: "تعذّر حفظ الموقِّع",
      titleAudit: "تقرير المراجع", titleReview: "تقرير الفحص", loadFailed: "تعذّر تحميل التقرير", generated: "تم إنشاء نسخة من التقرير",
      generateFailed: "فشل الإنشاء", editFailed: "فشل التعديل", generate: "إنشاء", regenerate: "إعادة الإنشاء (نسخة جديدة)", word: "وورد (.docx)",
      partnerSignoff: "توقيع الشريك", makeFinal: "اعتماد نهائي", finalDone: "التقرير نهائي", finalBlocked: "لم تتحقق شروط الاعتماد النهائي",
      signoffWarningsTitle: "تنبيهات التوقيعات (لا تمنع إصدار التقرير)",
      partnerUnsigned: "لم يوقّع الشريك على هذا الإصدار من التقرير",
      finalPartnerOnly: "يقتصر اعتماد التقرير نهائيًا على شريك الارتباط",
      whyTitle: "لماذا هذا التقرير", overridden: "تجاوز الشريك", compareWith: "قارن مع…", differences: "اختلافات",
      mergeTitle: "تعديلات يدوية من النسخة السابقة — احتفظ بتعديلي أو خذ الجديد", keepMine: "احتفظ بتعديلي", takeNewHint: "(النص الجديد معروض أدناه)",
      reasonRequired: "سبب تغيير الصياغة الإلزامية (مطلوب)", requiredWording: "صياغة إلزامية (ISA / ISRE)", aiDraft: "مسودة ذكاء اصطناعي",
      requiredChanged: "تم تغيير الصياغة الإلزامية", empty: "لا توجد نسخة بعد — اضغط إنشاء.",
      aiEstimate: "المسودة بالذكاء الاصطناعي: تقدير {units} وحدة لعدد {n} فقرة. المتابعة؟", aiDrafted: "تمت صياغة {n} فقرة — راجع واقبل", aiFailed: "فشلت المسودة",
      draftAll: "صياغة الكل بالذكاء الاصطناعي", draftWithAi: "صياغة بالذكاء الاصطناعي", accept: "قبول", reject: "رفض", sources: "المصادر", downloadFailed: "فشل التنزيل",
      pdfFinal: "PDF (نهائي)", uploadFinal: "رفع التقرير النهائي الموقّع (PDF)", finalFile: "التقرير النهائي الموقّع", uploadStored: "تم حفظ التقرير النهائي الموقّع مع المهمة وقفله",
      w12Link: "التغييرات فقط عبر تعديل ما بعد التجميع W12 ←", finalNote: "هذا التقرير نهائي. أي تغيير يتم عبر تعديل ما بعد التجميع W12 (سبب + مراجع).",
      regenNeeded: "يلزم إعادة الإنشاء — تغيّر الإطار ({from} ← {to}، بواسطة {by} في {at}). تُحفَظ النسخ الحالية للقراءة فقط.",
      fwMismatch: "بُنيت هذه النسخة على إطار مختلف عن القوائم المالية / قائمة الإفصاحات. أعد الإنشاء قبل الاعتماد النهائي.",
      eomOmTitle: "فقرات لفت الانتباه / أمور أخرى", eom: "لفت انتباه", om: "أمر آخر", topic: "الموضوع", noteRef: "مرجع الإيضاح", note: "إيضاح", addEntry: "إضافة", eomText: "النص (قابل للصياغة بالذكاء الاصطناعي في التقرير)",
    },
    engagements: {
      title: "المهام",
      // Batch 10 · Stage A — نسخ الارتباط
      rfAction: "ترحيل إلى السنة التالية",
      rfTitle: "ترحيل إلى السنة التالية",
      rfDesc: "ارتباط جديد للسنة المالية التالية: نفس العميل والفريق والإعدادات، بحالة التخطيط. يصبح دفتر الأستاذ وميزان المراجعة لهذه السنة سنةً سابقة له.",
      rfName: "اسم الارتباط الجديد",
      rfYear: "السنة المالية {fy} · الفترة من {from} إلى {to}",
      rfDatesAsk: "لا توجد تواريخ للفترة في هذا الارتباط. أدخل فترة الارتباط الجديد (السنة المالية {fy}).",
      rfStartLabel: "بداية الفترة",
      rfEndLabel: "نهاية الفترة",
      rfCarried: "يُرحَّل مع علامة «مرحَّل — حدِّث للسنة الحالية» (غير مكتمل حتى يُحفظ من جديد): النماذج، سجل المخاطر والاستجابات، إجابات قائمة الإفصاح، قائمة الأطراف ذات العلاقة. يُرحَّل ربط القوائم المالية؛ وتُعرض تقديرات وأهمية السنة السابقة للاطلاع فقط.",
      rfNotCarried: "لا يُرحَّل: الأهمية النسبية، أوراق العمل، العينات، المطابقة، التحريفات، التوقيعات، نقاط المراجعة، التقارير، سجل التدقيق، والمستندات غير المؤشَّر عليها «ملف دائم». أرقام السنة السابقة في السنة الجديدة هي أرقام الإقفال المُراجَعة: دفاتر العميل زائد قيود التسوية المرحّلة لهذه السنة (تُحفظ في السنة الجديدة كقيود تسوية سنة سابقة للقراءة فقط).",
      rfDocs: "مستندات الملف الدائم المراد ترحيلها",
      rfDocsNone: "لا يوجد مستند مؤشَّر عليه «ملف دائم». أشِّر عليها في صفحة المستندات أولاً.",
      rfSuggested: "غير مؤشَّر عليها، لكنها تبدو مستندات ملف دائم (أشِّر عليها في صفحة المستندات لترحيلها):",
      rfAlready: "تم ترحيل هذا الارتباط بالفعل إلى السنة المالية {fy}.",
      rfStart: "ترحيل",
      rfRunning: "جارٍ الترحيل…",
      rfQueued: "في الانتظار",
      rfDone: "جاهز: {name}",
      rfFailed: "تعذّر الترحيل",
      rfOpen: "فتح الارتباط الجديد",
      copyAction: "نسخ الارتباط",
      copyTitle: "نسخ الارتباط",
      copyDesc: "يُنشئ ارتباطًا جديدًا مفتوحًا للعميل نفسه والسنة المالية نفسها بعمل هذا الارتباط. لا يتغير الارتباط المصدر.",
      copyName: "اسم الارتباط للنسخة",
      copyNameHint: "يظهر في المحدِّد والقوائم ولوحة المعلومات. يُنسخ الاسم القانوني للعميل ({client}) دون تغيير — وهو ما يُطبع في تقرير المدقق والقوائم المالية.",   // Batch 14 · M13
      copyRef: "مرجع المهمة الداخلي للنسخة",
      copySameFy: "السنة المالية: {fy} (نفس سنة المصدر)",
      copyTickGl: "واردات دفتر الأستاذ العام وميزان المراجعة (الرئيسية وحسب البند)",
      copyTickDocs: "المستندات (يُنسخ كل ملف؛ لا مشاركة للملفات)",
      copyTickSamples: "العينات وأوراق التوثيق",
      copyTickMisst: "التحريفات",
      copyNever: "النسخة عمل جديد. لا يُنسخ أبدًا: التوقيعات بجميع أنواعها (المُعدّ / المراجع 1 / مراجع الجودة / الشريك على البنود، وعلامات سير عمل النماذج، وتوقيعات W9 / W10 / مراجعة الجودة / التقرير — فهي تسجّل من راجع الملف الأصلي)، ومراجعة الجودة (التعيين والمسائل — تُعاد على النسخة)، وإصدارات تقرير المدقق، والقفل وتجميع الملف، وسجل التدقيق، ونقاط المراجعة، والإشعارات. يُنسخ: تاريخ التقرير في W12 (محتوى الملف). تُفتح النسخة غير مقفلة.",
      copyStart: "نسخ",
      copyRunning: "جارٍ النسخ…",
      copyQueued: "في قائمة الانتظار",
      copyDone: "النسخة جاهزة: {name}",
      copyFailed: "تعذّر إنشاء النسخة — حاول مرة أخرى",
      copyOpen: "فتح النسخة",
      subtitle: "مهام تدقيق العملاء",
      newEng: "مهمة جديدة",
      client: "العميل",
      fy: "السنة المالية",
      currency: "العملة",
      materiality: "الأهمية النسبية",
      overallMateriality: "الأهمية النسبية الكلية",
      performanceMateriality: "الأهمية النسبية للتنفيذ",
      clearlyTrivial: "الحد غير المؤثر بوضوح (اختياري)",   // Batch 27 · D (M37)
      clearlyTrivialHint: "اتركه فارغاً لتحدده لاحقاً في 105(a). لا تُفترض قيمة افتراضية.",
      firmRef: "مرجع المهمة الداخلي",
      engName: "اسم الارتباط", rename: "إعادة تسمية الارتباط", renamePrompt: "اسم الارتباط (يظهر في المحدِّد والقوائم ولوحة المعلومات؛ لا يتغيّر الاسم القانوني للعميل في التقرير):", renamed: "تمت إعادة تسمية الارتباط",   // Batch 14 · M13
      lockedLabel: "مقفل", reportFinalLabel: "التقرير نهائي",   // Batch 14 · M14
      firmRefHint: "رقم / مرجع المهمة الداخلي الخاص بشركتك",
      periodEnd: "نهاية الفترة",
      periodStart: "بداية الفترة",
      periodStartHint: "اتركه فارغًا ليكون 12 شهرًا قبل نهاية الفترة.",
      addEng: "مهمة جديدة",
      addTitle: "إنشاء مهمة جديدة",
      contractedFee: "إجمالي الإيرادات / الأتعاب المتعاقد عليها",
      contractedFeeHint: "قابل للتعديل بواسطة الشريك فقط. يُستخدم في تبويب الفوترة / التجاوز.",
      budgetedHours: "إجمالي الساعات المخططة",
      budgetedHoursHint: "قد تتجاوز الساعات الفعلية هذا الرقم — سيتم تمييز المهمة كتجاوز.",
      seedNote: "قيم أولية فقط. بعد إنشاء المهمة، يجب أن تمر جميع تغييرات الأهمية النسبية / الأهمية النسبية للأداء عبر {matPath}؛ كل شاشة أخرى (العينات، إلخ) تسحب منها تلقائياً.",
      seedNotePath: "تقييم المخاطر ← الأهمية النسبية",
      pfLabel: "إطار العرض",
      pfErrorSelect: "اختر إطار العرض (IAS 1 أو IFRS 18) قبل إنشاء المهمة.",
      pfNote: "يحكم عرض الأرباح والخسائر (المجاميع الفرعية للفئات في IFRS 18 مقابل IAS 1 التقليدية). يمكن للشريك تغييره لاحقًا في إعدادات المهمة؛ بعد أول توليد للقوائم المالية يُبقي التغيير الإصدارات الحالية للقراءة فقط ويضع علامة \"يلزم إعادة التوليد\".",
      pfPlaceholder: "مثال: ENG-2024-017",
      requiresEqcLabel: "يتطلب مراجعة الجودة (EQ)",
      isaCitationEqc: "(ISQM 1 — مراجعات جودة الارتباط؛ ISA 220 (Revised)) — الجهات المدرجة والمهام عالية المخاطر",
      supportDocsLabel: "مستندات داعمة لهذه المهمة",
      glSamplesCol: "الأستاذ / العينات",
      findingsCol: "النتائج",
      signedOff: "موقّع",
      manageTeam: "إدارة فريق المهمة",
      deleteEngUnlockFirst: "افتح قفل المهمة قبل الحذف",
      deleteEngTooltip: "حذف المهمة",
      deleteEngTitle: "حذف المهمة؟",
      deleteEngDesc: "سيتم نقل {client} (السنة المالية {fy}) وكل محتوياته إلى سلة المحذوفات. يختفي من قائمة الارتباطات ويمكن استعادته من سلة المحذوفات؛ لا يُحذف أي شيء نهائيًا.",
      noClientName: "(بدون اسم عميل)",
      clientNameRequired: "أدخل اسم العميل قبل إنشاء الارتباط.",
      deleteEngYes: "نعم، احذف",
      created: "تم إنشاء المهمة",
      deleted: "تم حذف المهمة",
      deleteFailed: "فشل الحذف",
      failedCreate: "فشل",
      pfSetTooltip: "حدد إطار العرض",
      pfWithLabel: "الإطار: {pf}",
    },
    executive: {
      title: "لوحة التحكم التنفيذية",
      // Batch 24
      deletedTitle: "المهام المحذوفة ({n})", deletedHint: "في سلة المحذوفات — غير محسوبة في الأرقام أعلاه. يمكن استعادة أي منها من سلة المحذوفات.",
      dName: "المهمة", dDeletedAt: "تاريخ الحذف", dDeletedBy: "حذفه", deletedShow: "عرض", deletedHide: "إخفاء",
      subtitle: "التقدم على مستوى المحفظة والمخاطر والأهمية النسبية عبر كل مهمة",
      failedLoad: "فشل التحميل",
      kpiEngagements: "المهام",
      kpiSamples: "العينات المختبرة",
      kpiDocs: "المستندات",
      kpiHigh: "نتائج عالية",
      kpiGl: "قيود الأستاذ",
      kpiBurn: "استهلاك على مستوى الشركة",
      kpiInProgress: "{n} قيد التنفيذ",
      state: { completed: "مكتملة", signed_off: "موقّعة", in_progress: "قيد التنفيذ", planning: "التخطيط" },
      kpiCoverage: "{n}% تغطية",
      kpiPending: "{n} بند معلق",
      kpiFindingsBreak: "+{m} متوسطة · {l} منخفضة",
      kpiFirmwide: "على مستوى الشركة",
      kpiIdentified: "{n} محددة",
      portfolio: "محفظة المهام",
      cClient: "العميل",
      cFirmRef: "مرجع الشركة",
      cFy: "السنة المالية",
      cStatus: "الحالة",
      cProgress: "التقدم",
      cBurn: "استهلاك الأهمية النسبية",
      cHigh: "عالية",
      cMed: "متوسطة",
      cLow: "منخفضة",
      cPending: "معلقة",
      noEng: "لا توجد مهام بعد.",
      signedOffBy: "موقّع من قبل {name}",
      vouchingTested: "{done} / {total} تم اختبارها",
      heatMap: "خريطة حرارية للمخاطر (ISA 315)",
      heatMapEmpty: "لم تُدخل أي بنود مخاطر لمناطق القوائم المالية بعد. أضف المخاطر على صفحة تقييم المخاطر (تبويب ISA 315) لكل مهمة.",
      findingsByType: "النتائج حسب النوع",
      noFindings: "لا توجد نتائج بعد.",
      burnTitle: "استهلاك الأهمية النسبية (ISA 450)",
      burnDesc: "إجمالي التحريفات المحددة لكل مهمة مقابل الأهمية النسبية للأداء. أخضر < 50% · كهرماني من 50% إلى أقل من 100% · أحمر \u2265 100% (عند الأهمية النسبية للأداء أو فوقها).",
      burnLabel: "الاستهلاك",
      burnLegend: "% الاستهلاك",
    },

    docs: {
      title: "مراجعة المستندات",
      subtitle: "ارفع المستندات الداعمة وراجع الحقول المستخرجة",
      type: "نوع المستند",
      types: {
        auto: "كشف تلقائي (موصى به)",
        sales_invoice: "فاتورة مبيعات",
        auto: "مكتشف تلقائيًا", other_information: "معلومات أخرى", grn: "إشعار استلام بضاعة", bank_statement: "كشف حساب بنكي",
        purchase_invoice: "فاتورة مشتريات", po: "أمر شراء", contract: "عقد", boq: "جدول كميات", delivery_note: "إشعار تسليم",
        unclassified: "غير مصنف", org_logo: "شعار المكتب", financial_statements: "القوائم المالية", methodology: "المنهجية",
        purchase_invoice: "فاتورة مشتريات",
        po: "أمر شراء",
        contract: "عقد / اتفاقية",
        boq: "جدول كميات",
        grn: "إشعار استلام بضائع",
        delivery_note: "إشعار تسليم",
        bank_statement: "كشف حساب بنكي",
        confirmation: "مصادقة رصيد",
        subcontractor_certificate: "شهادة مقاول من الباطن",
        progress_certificate: "شهادة إنجاز",
        memo: "مذكرة / مستند داخلي",   // Batch 29 · item 8
        unclassified: "غير مصنف — مراجعة",
      },
      linkTo: "ربط بعنصر تدقيق",
      linkMulti: "يمكن ربط المستند الواحد بعدة عناصر عينة.",
      manageLinks: "إدارة الروابط",
      linkedTo: "مرتبط بـ",
      unlink: "فك الربط",
      delete: "حذف المستند",
      deleteConfirm: "حذف هذا المستند؟ لا يمكن التراجع.",
      extracted: "الحقول المستخرجة",
      preview: "معاينة المستند",
      upload: "رفع مستند",
      pending: "جاري الاستخراج…",
      retry: "إعادة المحاولة", retryQueued: "تمت جدولة القراءة — تُحدَّث الحالة عند الانتهاء.",
      done: "تم الاستخراج",
      failed: "فشل الاستخراج",
      dropzone: "أفلت الملف هنا أو انقر للاستعراض",
    },
    completion: {
      a4: {
        seeAlso: "انظر أيضًا:",
        finalEval: "الاستمرارية — التقييم النهائي والاستنتاج",
      },
    },
    ailog: {
      tab: "سجل الذكاء الاصطناعي", thisEng: "هذه المهمة", allEng: "كل المهمات", allFeatures: "كل الميزات", allUsers: "كل المستخدمين", export: "تصدير XLSX",
      empty: "لا توجد عمليات ذكاء اصطناعي مسجلة بعد", calls: "استدعاء",
      col: { when: "الوقت", user: "المستخدم", feature: "الميزة", engagement: "المهمة", asked: "ما طُلب", returned: "ما أعاده الذكاء الاصطناعي", sources: "المصادر", units: "الوحدات", decision: "القرار" },
      dec: { accept: "مقبول", edit: "معدّل ومقبول", reject: "مرفوض", mixed: "مقبول جزئيًا", pending: "لا قرار بعد" },
      feature: { risk_ai_suggest: "اقتراح المخاطر بالذكاء الاصطناعي", bulk_ai_suggest: "اقتراح الذكاء الاصطناعي لكل النماذج", ai_readout: "القراءة بالذكاء الاصطناعي", analytics_observations: "ملاحظات التحليلات بالذكاء الاصطناعي", dc_ai_premark: "التعليم المسبق لقائمة الإفصاحات", unit_test: "اختبار", methodology_extract: "استخراج المنهجية", report_narrative_draft: "صياغة سرد تقرير المراجع", report_firm_adaptation: "صياغة التقرير بأسلوب الشركة", discrepancy_explain: "شرح الفروقات", note_mapping_suggest: "اقتراح ربط الإيضاحات", unknown: "غير مصنف", assistant_chat: "المساعد الذكي", form_ai_suggest: "اقتراح النماذج", fs_mapping_suggest: "اقتراح ربط القوائم", note_editorial_draft: "مسودة الإيضاح", doc_extraction: "استخراج المستندات", doc_summary: "ملخصات المستندات" },

    },
  },
};

export default I18N_BASE_ENGAGEMENTS;
